(function () {
  if (window.HomePassionCartFixLoadedV3) return;
  window.HomePassionCartFixLoadedV3 = true;

  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function cartAddUrl() {
    return window.routes?.cart_add_url || '/cart/add.js';
  }

  function cartUrl() {
    return window.routes?.cart_url || '/cart';
  }

  // ─── Cart Update ────────────────────────────────────────────────────────────

  /**
   * Render the cart drawer using sections HTML returned by /cart/add.js
   * (parsedState.sections) OR fetched separately from /cart?sections=...
   */
  function renderCart(parsedState, trigger) {
    // Prefer the global HomePassionCartDrawer helper defined in cart-drawer.js
    if (window.HomePassionCartDrawer && typeof window.HomePassionCartDrawer.render === 'function') {
      window.HomePassionCartDrawer.render(parsedState, trigger);
      return;
    }

    // Fallback: manual DOM update (should not be needed but kept as safety net)
    const drawerHTML = parsedState?.sections?.['cart-drawer'];
    const bubbleHTML = parsedState?.sections?.['cart-icon-bubble'];
    const parser = new DOMParser();

    if (drawerHTML) {
      const newDoc = parser.parseFromString(drawerHTML, 'text/html');
      const newDrawer = newDoc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.classList.remove('is-empty');
        currentDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
      }
    }

    if (bubbleHTML) {
      const newDoc = parser.parseFromString(bubbleHTML, 'text/html');
      const newBubble = newDoc.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');
      if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
    }

    openCartDrawer(trigger);
  }

  function openCartDrawer(trigger) {
    if (window.HomePassionCartDrawer && typeof window.HomePassionCartDrawer.open === 'function') {
      window.HomePassionCartDrawer.open(trigger);
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location.href = cartUrl(); return; }
    drawer.classList.remove('is-empty');
    if (typeof drawer.open === 'function') drawer.open(trigger);
    else { drawer.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
  }

  // ─── Add to Cart ─────────────────────────────────────────────────────────────

  async function addItemByJSON(variantId, quantity, properties) {
    const body = {
      id: Number(variantId),
      quantity: Number(quantity || 1),
      sections: CART_SECTIONS,
      sections_url: window.location.pathname,
    };
    if (properties && Object.keys(properties).length) body.properties = properties;

    const response = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
    return data;
  }

  async function addItemByForm(form) {
    const formData = new FormData(form);
    formData.append('sections', CART_SECTIONS.join(','));
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
    return data;
  }

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  function getVariantIdFromScope(scope, button) {
    if (button?.dataset?.variantId) return button.dataset.variantId;
    if (button?.getAttribute?.('data-variant-id')) return button.getAttribute('data-variant-id');
    const checked = scope.querySelector('input[name="id"]:checked');
    if (checked?.value) return checked.value;
    const select = scope.querySelector('select[name="id"]');
    if (select?.value) return select.value;
    const hidden = scope.querySelector('input[name="id"]');
    if (hidden?.value) return hidden.value;
    return null;
  }

  function getQuantityFromScope(scope, button) {
    if (button?.dataset?.quantity) return button.dataset.quantity;
    const quantityInput = scope.querySelector('input[name="quantity"]');
    return quantityInput?.value || 1;
  }

  function showInlineError(scope, message) {
    let error = scope.querySelector('[data-cart-ajax-error]');
    if (!error) {
      error = document.createElement('div');
      error.setAttribute('data-cart-ajax-error', '');
      error.style.cssText = 'margin-top:10px;font-size:13px;line-height:1.4;color:#b00020';
      const target = scope.querySelector('[type="submit"], button[name="add"], .premium-product-card__ajax-add, .showcase-atc-btn, #showcaseModalAtcBtn') || scope;
      target.insertAdjacentElement('afterend', error);
    }
    error.textContent = message;
  }

  function closePossiblePopup(source) {
    const popup = source.closest('.variant-popup, .product-popup, .quick-add-modal, quick-add-modal, modal-dialog, .showcase-variant-modal, #showcaseVariantModalOverlay');
    if (!popup) return;
    if (typeof popup.hide === 'function') { popup.hide(true); return; }
    const closeButton = popup.querySelector('.modal__close-button, .quick-add-modal__toggle, [data-modal-close], .popup-close, button[aria-label="Close"], button[aria-label="Kapat"]');
    if (closeButton) { closeButton.click(); return; }
    popup.removeAttribute('open');
    popup.classList.remove('active', 'is-active', 'open');
    document.body.classList.remove('overflow-hidden');
  }

  function setLoading(source, loading) {
    if (!source) return;
    source.disabled = loading;
    source.classList.toggle('loading', loading);
    const spinner = source.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  // ─── Button Add (product cards, popups with data-variant-id) ─────────────────

  async function handleButtonAdd(button) {
    const scope = button.closest('form, .premium-product-card, .product-card-wrapper, .card-wrapper, .quick-add-modal, quick-add-modal, modal-dialog, .variant-popup, .product-popup, .showcase-card') || document;
    const variantId = getVariantIdFromScope(scope, button);
    const quantity = getQuantityFromScope(scope, button);

    if (!variantId) { showInlineError(scope, 'Lütfen bir varyant seçin.'); return; }

    const textEl = button.querySelector('span:not(.visually-hidden)') || button;
    const oldText = textEl?.textContent;

    setLoading(button, true);
    if (textEl && oldText && !button.classList.contains('premium-product-card__round-action')) {
      textEl.textContent = 'Ekleniyor...';
    }

    try {
      const parsedState = await addItemByJSON(variantId, quantity);
      closePossiblePopup(button);
      renderCart(parsedState, button);

      if (textEl && oldText && !button.classList.contains('premium-product-card__round-action')) {
        textEl.textContent = 'Eklendi ✓';
        setTimeout(() => { textEl.textContent = oldText; }, 900);
      }
    } catch (error) {
      showInlineError(scope, error.message || 'Ürün sepete eklenirken hata oluştu.');
      if (textEl && oldText && !button.classList.contains('premium-product-card__round-action')) {
        textEl.textContent = oldText;
      }
    } finally {
      setLoading(button, false);
    }
  }

  // ─── Form Add (popup/modal forms NOT managed by <product-form> element) ────

  async function handleFormAdd(form, submitButton) {
    const scope = form;
    const textEl = submitButton?.querySelector('span:not(.visually-hidden)') || submitButton;
    const oldText = textEl?.textContent;

    setLoading(submitButton, true);
    if (textEl && oldText) textEl.textContent = 'Ekleniyor...';

    try {
      const parsedState = await addItemByForm(form);
      closePossiblePopup(submitButton || form);
      renderCart(parsedState, submitButton || form);

      if (textEl && oldText) {
        textEl.textContent = 'Eklendi ✓';
        setTimeout(() => { textEl.textContent = oldText; }, 900);
      }
    } catch (error) {
      showInlineError(scope, error.message || 'Ürün sepete eklenirken hata oluştu.');
      if (textEl && oldText) textEl.textContent = oldText;
    } finally {
      setLoading(submitButton, false);
    }
  }

  // ─── Global API ──────────────────────────────────────────────────────────────

  window.HomePassionCart = {
    refresh: async function () {
      if (window.HomePassionCartDrawer?.refresh) return window.HomePassionCartDrawer.refresh();
    },
    open: openCartDrawer,
    addItem: addItemByJSON,
    refreshAndOpen: async function (trigger) {
      if (window.HomePassionCartDrawer?.refresh) {
        await window.HomePassionCartDrawer.refresh();
        openCartDrawer(trigger);
      }
    },
  };

  document.addEventListener('cart:refresh', function () {
    window.HomePassionCart.refreshAndOpen();
  });

  // ─── FORM SUBMIT LISTENER ────────────────────────────────────────────────────
  // Only intercept forms that are NOT already managed by the <product-form> custom element.
  // <product-form> sets data-product-form-managed="true" on its inner form in its constructor.

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('form');
      if (!form) return;

      // SKIP: form is managed by <product-form> custom element
      if (form.dataset.productFormManaged === 'true') return;

      const action = form.getAttribute('action') || '';
      const isProductForm =
        action.includes('/cart/add') ||
        form.querySelector('input[name="form_type"][value="product"]') ||
        form.querySelector('input[name="id"], select[name="id"]');

      if (!isProductForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = event.submitter || form.querySelector('[type="submit"], button[name="add"], .btn-atc');
      handleFormAdd(form, submitButton);
    },
    true // capture phase to catch early
  );

  // ─── BUTTON CLICK LISTENER ───────────────────────────────────────────────────
  // Handles standalone ATC buttons (product cards, custom showcase buttons, popups)
  // that are NOT inside a <product-form> managed form.

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        [
          '.premium-product-card__ajax-add',
          '.showcase-atc-btn[data-variant-id]',
          '#showcaseModalAtcBtn',
          '[data-popup-add-to-cart]',
          '.variant-popup-add-to-cart',
          '[data-variant-id][data-quantity]',
          'button[data-variant-id]:not([type="submit"])',
        ].join(',')
      );

      if (!button) return;

      // Skip if inside a <product-form> managed form
      const parentForm = button.closest('form');
      if (parentForm && parentForm.dataset.productFormManaged === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      handleButtonAdd(button);
    },
    true
  );
})();